import { useEffect, useRef, useState } from "react";
import { fetchPhotoBlob } from "@/lib/api";
import { ImageOff } from "lucide-react";

/** Loads photos via authenticated axios call and shows via blob URL.
 *  No token ever appears in the URL. */
export default function AuthImage({ photoId, alt = "Foto", className = "" }) {
    const [src, setSrc] = useState(null);
    const [failed, setFailed] = useState(false);
    const urlRef = useRef(null);

    useEffect(() => {
        let cancelled = false;
        if (!photoId) return;
        setFailed(false);
        setSrc(null);
        (async () => {
            try {
                const blob = await fetchPhotoBlob(photoId);
                if (cancelled) return;
                const url = URL.createObjectURL(blob);
                urlRef.current = url;
                setSrc(url);
            } catch (e) {
                if (!cancelled) setFailed(true);
            }
        })();
        return () => {
            cancelled = true;
            if (urlRef.current) {
                URL.revokeObjectURL(urlRef.current);
                urlRef.current = null;
            }
        };
    }, [photoId]);

    if (failed) {
        return (
            <div className={`flex items-center justify-center bg-mes-surfaceAlt text-mes-muted ${className}`}>
                <ImageOff className="h-5 w-5" />
            </div>
        );
    }
    if (!src) {
        return <div className={`animate-pulse bg-mes-surfaceAlt ${className}`} />;
    }
    return (
        <img
            src={src}
            alt={alt}
            className={className}
            data-testid={`auth-img-${photoId}`}
            loading="lazy"
        />
    );
}
